import { useColorMode } from '@vueuse/core';
import { inject } from 'vue';

import type { Plugin, InjectionKey, Ref } from 'vue';

export interface Theme {
  colorMode: Ref<'light' | 'dark'>;
}

const injectionKey: InjectionKey<Theme> = Symbol('UploadContext');

export const themePlugin: Plugin = {
  install(app, options) {
    const colorMode = useColorMode({
      initialValue: 'dark',
    });
    app.provide(injectionKey, {
      colorMode: colorMode.state,
    });
  },
};
export function useTheme() {
  return inject(injectionKey)!;
}
